export function inferLanguageFromUrlParams(): string | null {
  const params = new URL(window.location.href).searchParams;

  const uriLang = params.get('lang');
  return uriLang ? uriLang.toLowerCase() : null;
}
